import { Injectable } from '@angular/core';
import { promotionConstants } from '../ocado-constants';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class IndexedDBService {
  private dbName = promotionConstants.indexedDBName;
  private promotionStoreName = promotionConstants.promotionsStoreName;
  private proposalStoreName = promotionConstants.proposalsStoreName;
  public db: IDBDatabase | null = null;

  public promotionBaseUrl = '';
  public proposalBaseUrl = '';
  constructor(private http: HttpClient) {
    this.promotionBaseUrl = environment.promotionBaseUrl;
    this.proposalBaseUrl = environment.proposalBaseUrl;
  }
  async initDB(): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, 1);

      request.onupgradeneeded = (event: any) => {
        const db = event.target.result as IDBDatabase;
        this.db = db;

        if (!db.objectStoreNames.contains(this.promotionStoreName)) {
          db.createObjectStore(this.promotionStoreName, { keyPath: 'promotion_id' });
        }

        if (!db.objectStoreNames.contains(this.proposalStoreName)) {
          db.createObjectStore(this.proposalStoreName, { keyPath: 'proposal_id' });
        }
      };

      request.onsuccess = (event: any) => {
        this.db = event.target.result as IDBDatabase;
        resolve();
      };

      request.onerror = (event: any) => {
        reject(event.target.error);
      };
    });
  }

  addData(data: any, storeName: string) {
    if (this.db) {
      const store = this.transactionFunc(storeName, 'readwrite');
      return this.promiseFunc(store.add(data));
    } else {
      return;
    }
  }
  updateData(data: any, storeName: string) {
    if (this.db) {
      const store = this.transactionFunc(storeName, 'readwrite');
      return this.promiseFunc(store.put(data));
    } else {
      return;
    }
  }
  getData(id: string | number, storeName: string) {
    if (!this.db) {
      return Promise.reject('DB not initialized'); // <-- pass rejection value
    }

    const store = this.transactionFunc(storeName, 'readonly');
    return this.promiseFunc(store.get(+id));
  }

  deleteData(id: string | number, storeName: string) {
    if (this.db) {
      const store = this.transactionFunc(storeName, 'readwrite');
      return this.promiseFunc(store.delete(+id));
    } else {
      return;
    }
  }
  deleteAllData(storeName: string) {
    const store = this.transactionFunc(storeName, 'readwrite');
    return this.promiseFunc(store.clear());
  }

  transactionFunc(storeName: string, mode: IDBTransactionMode) {
    if (!this.db) {
      throw new Error('Database not initialized');
    }

    const transaction = this.db.transaction(storeName, mode);
    return transaction.objectStore(storeName);
  }

  promiseFunc(method: any) {
    return new Promise((resolve, reject) => {
      const request = method;
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }
}
